/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const people_1_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M14.604 17.9a.75.75 0 1 0 .792 1.274l-.792-1.274Zm5.632 4.646a.75.75 0 1 0 1.497-.092l-1.497.092ZM17 4.25a.75.75 0 0 0 0 1.5v-1.5Zm-2.55 9.15a.75.75 0 1 0-.901 1.2l.901-1.2Zm-2.212 9.14a.75.75 0 1 0 1.498-.08l-1.498.08Zm-9.974-.08a.75.75 0 0 0 1.498.08l-1.498-.08Zm13.132-3.286c.425-.264.953-.424 1.604-.424v-1.5c-.909 0-1.715.227-2.396.65l.792 1.274ZM17 18.75c1.023 0 1.767.395 2.289 1.029.538.655.877 1.614.947 2.767l1.497-.092c-.084-1.373-.493-2.664-1.286-3.628-.81-.984-1.98-1.576-3.447-1.576v1.5ZM21.25 10A4.25 4.25 0 0 1 17 14.25v1.5A5.75 5.75 0 0 0 22.75 10h-1.5ZM17 5.75A4.25 4.25 0 0 1 21.25 10h1.5A5.75 5.75 0 0 0 17 4.25v1.5Zm0 8.5c-.958 0-1.84-.316-2.55-.85l-.901 1.2A5.728 5.728 0 0 0 17 15.75v-1.5Zm-9 3.5c1.36 0 2.353.513 3.038 1.328.702.834 1.125 2.038 1.2 3.462l1.498-.08c-.088-1.656-.585-3.201-1.55-4.348-.981-1.165-2.4-1.862-4.186-1.862v1.5Zm-4.238 4.79c.075-1.424.498-2.628 1.2-3.462C5.647 18.263 6.64 17.75 8 17.75v-1.5c-1.786 0-3.205.697-4.186 1.862-.965 1.147-1.462 2.692-1.55 4.349l1.498.079ZM13.25 7c0 2.9-2.35 5.25-5.25 5.25v1.5A6.75 6.75 0 0 0 14.75 7h-1.5ZM8 12.25A5.25 5.25 0 0 1 2.75 7h-1.5A6.75 6.75 0 0 0 8 13.75v-1.5ZM2.75 7C2.75 4.1 5.1 1.75 8 1.75V.25A6.75 6.75 0 0 0 1.25 7h1.5ZM8 1.75c2.9 0 5.25 2.35 5.25 5.25h1.5A6.75 6.75 0 0 0 8 .25v1.5Z"
    />
  </svg>
)
export default people_1_medium
